import { hasFeatureFlags } from 'utils/features';

/**
 * Calls the hasFeatureFlag
 * Do not pass feature props around!
 *
 * @example
 * const hasCertifications = useFeatureFlags(['certifications']);
 *
 */
export default function useFeatureFlags(features = []) {
  return hasFeatureFlags(features);
}
